<button [ngClass]="'cb-button-'+type" [class.disabled]="disabled" [class.full-width]="fullWidth"
  (click)="click($event)">
  <div class="cb-button-content">
    <cb-icon *ngIf="icon" [name]="icon"></cb-icon>
    <ng-content></ng-content>
  </div>
</button>
